import invitation from './invitation'
import appRating from './appRating'
import livePreview from './livePreview'

export default { invitation, appRating , livePreview}

export const Preview = {
  invitation, appRating , livePreview
};
